<template>
  <div>
    <div v-show="showBar" class="bar" ref="bar">
      <div><van-icon name="arrow-left" @click.stop="goBack" class="nav-icon"/></div>
      <div><van-icon name="ellipsis" class="nav-icon rotate-90"/></div>
    </div>
    <div class="player-container">
      <div class="overlay" v-show="reject">
        <h3>升级SVIP, 畅享受所有视频资源</h3>
        <van-button color="#fb7a9f" @click="this.$router.push('/user/upgrade')">升级SVIP</van-button>
      </div>
      <div class="overlay" v-show="unLogin">
        <h3>需要SVIP会员登录，才可以观看视频</h3>
        <van-button color="#fb7a9f" @click="this.$router.push('/login')">登录</van-button>
      </div>
      <video playsinline ref="plyrVideo" preload="auto" :poster="poster" style="--plyr-color-main: #fb7a9f;" @canplay="handleCanPlay">
        <source/>
      </video>
      <div class="video_loader">
        <div class="loader" v-if="loading"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';
import Hls from "hls.js";
import store from "@/store";

export default defineComponent({
  name: 'PlyrPlayer',
  props: {
    poster: {
      type: String,
    },
    options: {
      type: Object,
      default: () => ({})
    },
    hls:{
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      plyrInstance: null,
      V_LENGTH: 1,
      showBar: true,
      playList:[],
      onChange:null,
      sources:null,
      reject:false,
      currentTime:null,
      isPlaying:false,
      unLogin:false,
      isPlay:false,
      videoLoaded:false
    };
  },
  async mounted() {
    if (!this.isLogin) {
      this.unLogin = true
      sessionStorage.setItem('redirectPath', this.$route.fullPath);
    } else if (!this.isAuthor) {
      sessionStorage.setItem('redirectPath', this.$route.fullPath);
      this.reject = true
    } else {
      await this.getVideoUrls();
    }
    this.initializePlyr();
  },
  beforeUnmount() {
    if (this.plyrInstance) {
      this.plyrInstance.destroy();
    }
  },
  methods: {
    initializePlyr() {
      const hlsSources = this.playList.filter(video => video.type !== 'video/mp4');
      const mp4Sources = this.playList.filter(video => video.type === 'video/mp4');
      const qualityOptions = this.playList.map(video => video.quality);

      if (hlsSources.length > 0) {
        this.plyrInstance = new Plyr(this.$refs.plyrVideo, {
          controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'captions', 'settings', 'airplay', 'fullscreen'],
          settings: ['captions', 'quality', 'speed', 'loop'],
          // ratio: '16:9',
          quality: {
            forced: true, // 强制显示质量切换
            options:qualityOptions,
            onChange:(quality)=>{
              console.log(quality)
              const selectedSource = this.playList.find(video => video.quality === quality);
              if (selectedSource && selectedSource.type === 'application/x-mpegURL'){
                this.currentTime = this.plyrInstance?.currentTime;
                this.updateHlsSource(selectedSource);
              }
            },
          },
          autoplay: false,
          fullscreen: {
            enabled: true,
            fallback: true,
            iosNative: true,  // 启用 iOS 原生全屏
          },
          ...this.options,
        });
      }
      else {
        this.sources = {
          type: 'video',
          sources: mp4Sources
        };
        this.plyrInstance = new Plyr(this.$refs.plyrVideo, {
          controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'captions', 'settings', 'airplay', 'fullscreen'],
          settings: ['captions', 'quality', 'speed', 'loop'],
          // ratio: '16:9',
          quality: {
            forced: true, // 强制显示质量切换
            options:qualityOptions,
          },
          autoplay: false,
          fullscreen: {
            enabled: true,
            fallback: true,
            iosNative: true,  // 启用 iOS 原生全屏
          },
          ...this.options,
        });
        this.plyrInstance.source = this.sources
      }
      this.plyrInstance.poster = this.poster
      this.plyrInstance.on('controlshidden', () => {
        this.showBar = false;
      });
      this.plyrInstance.on('controlsshown', () => {
        setTimeout(()=>{
          this.showBar = true;
        }, 200)
      });
      this.plyrInstance.on('error', (event) => {
        console.error('Plyr error:', event.detail);
        const { code, message } = event.detail;
        console.log(`Plyr error code: ${code}, message: ${message}`);
      });
      this.plyrInstance.on('play', ()=>{
        this.isPlay = true;
      });
      this.plyrInstance.on('pause', () => {
        this.isPlay = false;
      });
    },
    async getVideoUrls() {
      if (this.playList.length > 0) return;
      try {
        const res = await this.$v_http.get(`getUrl?vid=${this.$route.query.pid}&nid=${this.getNid}`);
        if (res.data?.code === -101) {
          this.unLogin = true
          return
        }
        const videoData = res.data?.data || [];
        if (videoData.length > 0) {
          this.playList = videoData.map(video => ({
            src: video.Address,
            type: video.Type,
            quality:video.Quality
          }));
        }
      } catch (error) {
        console.error("Error fetching video URLs:", error);
      }
      // console.log(this.playList)
      // this.playList = [{src:"https://moav.com/get_file/1/5f5f2f66cb2fc95de48c25fecf71b891427a3ee27b/60000/60072/60072.mp4/", type:"application/x-mpegURL", quality:720}]
    },
    updateHlsSource(selectedSource) {
      if (this.plyrInstance) {
        this.isPlaying = !this.plyrInstance.paused;
      }
      let hls = new Hls({
        lowLatencyMode: true,
        maxBufferLength: 30, // 最大缓冲时长，可根据需求调整
      });
      hls.loadSource(selectedSource.src); // 加载新的 HLS 源
      hls.attachMedia(this.$refs.plyrVideo); // 绑定到 <video> 元素
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        this.plyrInstance.on('loadedmetadata', () => {
          this.plyrInstance.currentTime = this.currentTime; // 恢复播放进度
          if (this.isPlaying) {
            this.plyrInstance.play().catch(error => {
              console.log("Error trying to play after source change:", error);
            });
          }
        });
      });
    },
    goBack(){
      const path = sessionStorage.getItem('currentPath') || '/';
      this.$router.push(path);
    },
    handleCanPlay() {
      this.videoLoaded = true;
    },
  },
  computed:{
    isLogin(){
      return store.getters.isAuthenticated;
    },
    isAuthor(){
      const svip = store.getters.getUser?.svip;
      const currentDate = Math.floor(new Date().getTime()/1000)
      if (svip?.type==0 || svip?.due_date < currentDate || svip?.status > 0 || svip==null) {
        return false;
      }
      return true;
    },
    getNid(){
      let nid = this.$route.query.nid||0
      return nid!=1?nid:0
    },
    loading(){
      return this.isPlay && !this.videoLoaded
    },
  },
  watch:{
    async isAuthor(v){
      if (v) {
        this.$router.go(0)
      }
    }
  }
});
</script>

<style scoped lang="scss">
.bar {
  position: absolute;
  width: 100%;
  z-index: 100;
  padding: 3vw;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  background: linear-gradient(#000000bf, #0000);
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
  transition: opacity .4s ease-in-out, transform .4s ease-in-out;

  .nav-icon {
    font-size: 6vw;
    color: #ffffff;
    cursor: pointer;
  }
}

.rotate-90 {
  transform: rotate(90deg);
}

.player-container {
  position: relative;
  max-width: 800px;
  margin: auto;
  z-index: 10;
  video {
    width: 100%; /* 确保 video 和父容器宽度一致 */
    height: auto; /* 自动适应高度 */
    object-fit: contain;
    display: block; /* 去掉默认内边距和间距 */
  }
}
/* 覆盖层样式 */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* 透明背景，0.5 是透明度 */
  z-index: 20; /* 确保覆盖层在视频上 */
  display: flex;
  flex-direction: column;
  padding: 5vw;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  h3{
    color: white;
  }
}
:root {
  --plyr-color-main: #1ac266;
}

.video_loader{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) !important;
}
/* HTML: <div class="loader"></div> */
.loader {
  width: 38px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: .5rem solid #fb7a9f;
  animation:
      l20-1 0.8s infinite linear alternate,
      l20-2 1.6s infinite linear;
}
@keyframes l20-1{
  0%    {clip-path: polygon(50% 50%,0       0,  50%   0%,  50%    0%, 50%    0%, 50%    0%, 50%    0% )}
  12.5% {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100%   0%, 100%   0%, 100%   0% )}
  25%   {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100% 100%, 100% 100%, 100% 100% )}
  50%   {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100% 100%, 50%  100%, 0%   100% )}
  62.5% {clip-path: polygon(50% 50%,100%    0, 100%   0%,  100%   0%, 100% 100%, 50%  100%, 0%   100% )}
  75%   {clip-path: polygon(50% 50%,100% 100%, 100% 100%,  100% 100%, 100% 100%, 50%  100%, 0%   100% )}
  100%  {clip-path: polygon(50% 50%,50%  100%,  50% 100%,   50% 100%,  50% 100%, 50%  100%, 0%   100% )}
}
@keyframes l20-2{
  0%    {transform:scaleY(1)  rotate(0deg)}
  49.99%{transform:scaleY(1)  rotate(135deg)}
  50%   {transform:scaleY(-1) rotate(0deg)}
  100%  {transform:scaleY(-1) rotate(-135deg)}
}

</style>
